export const TEXT = {
    INVITE_MEMBERS: 'Invite Members',
    INVITE_MEMBERS_DESCRIPTION: 'Search for members by typing in their email address',
    ADD_MEMBERS: 'Add Members'
}